<div class="history-title">History</div>

<div class="history-items" #contentElementRef>
  @if (!loading) {
    @for (item of transactionHistoryItems; track item; let i = $index) {
      <app-history-item
        [item]="item"
        [isLastItem]="transactionHistoryItems ? i === transactionHistoryItems.length - 1 : false"
        [isFirstItem]="i === 0"
        [isExpandedByDefault]="item.id === firstItemWithSubItems"
        [loading]="loading"
        [currentTransactionId]="transactionId"
      />
    }
    @if (!transactionHistoryItems.length) {
      <div class="empty-history">Transaction history is empty.</div>
    }
  } @else {
    <app-history-item [loading]="true" [isFirstItem]="true" />
    <app-history-item [loading]="true" />
    <app-history-item [loading]="true" [isLastItem]="true" />
  }
</div>
